(function () {
  'use strict';

  var bloecke = document.querySelectorAll('.mb');
  if (!bloecke.length) return;

  var PROXY = (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db';
  var WURZEL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function bildAdresse(u) {
    if (typeof u !== 'string' || !u) return '';
    return u.indexOf('/media/') === 0 ? PROXY + u : u;
  }

  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }

  function zoll(v) {
    var n = parseFloat(v);
    if (!isFinite(n)) return '';
    return String(Math.round(n * 10) / 10).replace('.', ',') + '"';
  }
  function kilo(g) {
    var n = parseFloat(g);
    if (!isFinite(n) || n <= 0) return '';
    return String(Math.round(n / 100) / 10).replace('.', ',') + ' kg';
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  bloecke.forEach(function (block) {
    if (block.__mb) return;
    block.__mb = true;

    var cta = block.querySelector('[data-mb-cta]');
    if (cta) {
      cta.addEventListener('click', function (ev) {
        var feld = document.querySelector('[data-fh2-input]');
        if (!feld) return;
        ev.preventDefault();
        feld.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { try { feld.focus({ preventScroll: true }); } catch (e) { feld.focus(); } }, 400);
      });
    }

    function woGilt() {
      var an = block.querySelector('[data-mb-wo].is-an');
      return (an && an.getAttribute('data-mb-wo')) || 'tischhalterung';
    }

    function anzahlVon(karte) {
      var n = parseInt(karte.getAttribute('data-mb-anzahl'), 10);
      return (n >= 1 && n <= 4) ? n : 1;
    }

    var preisCache = {};
    function preisVon(handle) {
      if (!preisCache[handle]) {
        preisCache[handle] = fetch(WURZEL + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (pd) { return pd ? Number(pd.price) : null; })
          .catch(function () { return null; });
      }
      return preisCache[handle];
    }
    function guenstigsteOne(kaufbar) {
      var ones = kaufbar.filter(function (k) { return k.empfehlung === 'one'; });
      if (!ones.length) return Promise.resolve(null);
      return Promise.all(ones.map(function (k) { return preisVon(k.product.handle); }))
        .then(function (preise) {
          var best = null, bestPreis = Infinity;
          ones.forEach(function (k, i) {
            var p = preise[i];
            if (p != null && p < bestPreis) { best = k; bestPreis = p; }
          });
          return best || ones[0];
        });
    }

    var teileCache = {};
    function teileHolen(ref) {
      if (teileCache[ref]) return teileCache[ref];
      teileCache[ref] = abruf(PROXY + '/monitors/' + encodeURIComponent(ref) + '/compatibility')
        .then(function (a) {
          var k = (a && a.data) || a;
          return (k && k.recommendations) || [];
        })
        .catch(function () { return []; });
      return teileCache[ref];
    }

    function loesungFuellen(karte, monitor) {
      var nameEl    = karte.querySelector('[data-mb-loesung]');
      var teileEl   = karte.querySelector('[data-mb-teile]');
      if (!nameEl) return;

      if (karte.getAttribute('data-mb-fest') === 'ja') {
        var fest = karte.querySelector('[data-mb-mountbild]');
        if (fest) bildEinsetzen(fest, fest.getAttribute('data-mb-bild'));
        teileZeigen(teileEl, monitor, null);
        return;
      }

      var arten = woGilt().split(',').map(function (w) {
        return 'mount_type=' + encodeURIComponent(w);
      }).join('&');

      var anzahl = anzahlVon(karte);
      var geraete = [];
      for (var g = 0; g < anzahl; g++) geraete.push('m=' + encodeURIComponent(monitor.ref || ''));

      abruf(PROXY + '/combinations/compatible?' + geraete.join('&') + '&' + arten).then(function (a) {
        var k = (a && a.data) || a;
        var liste = (k && k.combinations) || [];
        var kaufbar = liste.filter(function (k) {
          return k.product && k.product.handle && k.product.in_shop;
        });

        var bevorzugt = (block.getAttribute('data-mb-bevorzugt') || '')
          .split(',').map(function (h) { return h.trim(); }).filter(Boolean);

        var treffer = null;
        for (var b = 0; b < bevorzugt.length && !treffer; b++) {
          for (var j = 0; j < kaufbar.length; j++) {
            if (kaufbar[j].product.handle === bevorzugt[b]) { treffer = kaufbar[j]; break; }
          }
        }
        var wahl = treffer ? Promise.resolve(treffer) : guenstigsteOne(kaufbar);
        wahl.then(function (treffer) {
        if (!treffer) treffer = kaufbar[0] || null;

        if (!treffer) {
          if (nameEl) nameEl.textContent = karte.getAttribute('data-mb-leer') || '';
          if (teileEl) teileEl.innerHTML = '';
          return;
        }

        if (nameEl) nameEl.textContent = treffer.product.name || '';

        teileZeigen(teileEl, monitor, treffer);

        if (nameEl) {
          fetch(WURZEL + 'products/' + encodeURIComponent(treffer.product.handle) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (pd) {
              if (!pd) return;
              if (nameEl && pd.title) {
                var teile = String(pd.title).split(' · ');
                if (teile.length > 1 && /^3IDEE/.test(teile[0])) {
                  var serie = teile.shift().replace(/\s+Monitorhalterung$/, '');
                  nameEl.innerHTML = '<span class="mb__serie">' + esc(serie) + '</span>' + esc(teile.join(' · '));
                } else {
                  nameEl.textContent = pd.title;
                }
              }
              bildEinsetzen(karte.querySelector('[data-mb-mountbild]'), pd.featured_image);
            })
            .catch(function () {});
        }
        });
      }).catch(function () {});
    }

    function teilName(teil, monitorName, karte) {
      var titel = String(teil.name || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim();
      if (teil.type !== 'ADAPTER' || !monitorName) return titel;
      var muster = karte.getAttribute('data-mb-teil-fuer') || '@TEIL@ @GERAETE@';
      var trenner = muster.split('@TEIL@').pop().split('@GERAETE@')[0];
      var m = titel.match(/^(.*?)\s+für\s+/i);
      var pos = m ? m[1].length : (trenner.trim() ? titel.toLowerCase().indexOf(trenner.toLowerCase()) : -1);
      if (pos > 0) titel = titel.slice(0, pos);
      return muster.replace('@TEIL@', titel.trim()).replace('@GERAETE@', monitorName);
    }

    function bildEinsetzen(el, adresse) {
      if (!el || !adresse) return;
      el.innerHTML = '<img src="' + esc(adresse) + '" alt="" loading="lazy" '
                   + 'onerror="this.remove()">';
    }

    function funnelHolen(gewichtKg) {
      if (!(gewichtKg > 0)) return Promise.resolve([]);
      var schluessel = 'g' + Math.round(gewichtKg * 10);
      if (funnelCache[schluessel]) return funnelCache[schluessel];
      funnelCache[schluessel] = abruf(PROXY + '/funnel/recommendations?setup_total_weight_kg='
                                      + encodeURIComponent(gewichtKg.toFixed(1)))
        .then(function (a) {
          var k = (a && a.data) || a;
          return (k && k.recommendations) || [];
        })
        .catch(function () { return []; });
      return funnelCache[schluessel];
    }
    var funnelCache = {};

    function teileZeigen(el, monitor, treffer) {
      if (!el) return;
      var karte = el.closest ? el.closest('[data-mb-ref]') : null;
      if (!karte) return;
      var stueck = anzahlVon(karte);
      var gewicht = (treffer && treffer.setup_weight_kg != null)
                  ? parseFloat(treffer.setup_weight_kg)
                  : ((parseFloat(monitor.weight_g) || 0) / 1000) * stueck
                    + (treffer && parseFloat(treffer.weight_kg) || 0);

      Promise.all([teileHolen(monitor.ref), funnelHolen(gewicht)]).then(function (beide) {
        var empfehlungen = beide[0].map(function (r) { return { r: r, jeGeraet: true }; })
                    .concat(beide[1].map(function (r) { return { r: r, jeGeraet: false }; }));
        var zeilen = [];
        var gruppen = {};

        (empfehlungen || []).forEach(function (eintrag) {
          var r = eintrag.r;
          if (r.requirement !== 'REQUIRED' && r.requirement !== 'RECOMMENDED') return;
          if (r.alt_group) {
            if (gruppen[r.alt_group]) return;
            gruppen[r.alt_group] = true;
          }
          var teil = (r.products && r.products[0]) || null;
          if (!teil || !teil.name) return;
          zeilen.push({
            stufe: r.requirement,
            jeGeraet: eintrag.jeGeraet,
            name: teilName(teil, monitor.name, karte),
            bild: bildAdresse(teil.image_url),
            handle: (teil.in_shop && teil.handle) ? teil.handle : null
          });
        });

        if (!zeilen.length) { el.innerHTML = ''; return; }

        var menge = anzahlVon(karte);

        var wortPflicht  = el.getAttribute('data-mb-pflicht')  || 'Erforderlich';
        var wortEmpfehlung = el.getAttribute('data-mb-empfohlen') || 'Empfohlen';

        el.innerHTML = zeilen.map(function (z) {
          var pflicht = z.stufe === 'REQUIRED';
          return '<span class="mb__teil">'
               + '<span class="mb__teil-zeile">'
               + (z.bild ? '<img class="mb__teil-bild" src="' + esc(z.bild)
                         + '" alt="" loading="lazy" onerror="this.remove()">' : '')
               + '<span class="mb__stufe' + (pflicht ? '' : ' mb__stufe--empfohlen') + '">'
               + esc(pflicht ? wortPflicht : wortEmpfehlung) + '</span>'
               + '</span>'
               + '<span class="mb__teil-name">'
               + (menge > 1 && z.jeGeraet ? menge + ' × ' : '') + esc(z.name) + '</span>'
               + '</span>';
        }).join('');
      });
    }

    function reiterBinden(wahl) {
      block.querySelectorAll('[' + wahl + ']').forEach(function (reiter) {
      reiter.addEventListener('click', function () {
        if (reiter.classList.contains('is-an')) return;
        block.querySelectorAll('[' + wahl + ']').forEach(function (r) {
          var an = r === reiter;
          r.classList.toggle('is-an', an);
          r.setAttribute('aria-selected', an ? 'true' : 'false');
        });
        block.querySelectorAll('[data-mb-ref]').forEach(function (k) {
          if (k.__mbDaten) loesungFuellen(k, k.__mbDaten);
        });
        zieleSetzen();
        folienBegrenzen();
      });
      });
    }
    function zieleSetzen() {
      block.querySelectorAll('[data-mb-ref]').forEach(function (karte) {
        var ref = karte.getAttribute('data-mb-ref');
        if (!ref) return;
        var n = anzahlVon(karte);
        var ziel = WURZEL + 'pages/setup-finder?monitor=' + encodeURIComponent(ref);
        if (n > 1) ziel += '&anzahl=' + n;
        karte.setAttribute('href', ziel);
      });
    }

    var WAND_MAX = 5;

    function folienBegrenzen() {
      var anWand = woGilt().indexOf('wand') === 0;
      var i = 0;
      block.querySelectorAll('[data-mb-ref]').forEach(function (karte) {
        var folie = karte.closest('.resource-list__slide') || karte.parentElement;
        if (!folie) return;
        var weg = anWand && i >= WAND_MAX;
        if (weg) folie.setAttribute('hidden', '');
        else folie.removeAttribute('hidden');
        i++;
      });
      var spur = block.querySelector('.resource-list__carousel [ref="scroller"]')
              || block.querySelector('.resource-list__carousel');
      if (spur && spur.scrollLeft) spur.scrollLeft = 0;
    }

    reiterBinden('data-mb-wo');
    zieleSetzen();
    folienBegrenzen();

    block.querySelectorAll('[data-mb-ref]').forEach(function (karte) {
      var ref = karte.getAttribute('data-mb-ref');
      if (!ref) return;

      abruf(PROXY + '/monitors/' + encodeURIComponent(ref)).then(function (antwort) {
        var d = (antwort && antwort.data) || antwort;
        if (!d || !d.name) return;

        var nameEl = karte.querySelector('[data-mb-name]');
        if (nameEl) {
          var wieOft = anzahlVon(karte);
          nameEl.textContent = (wieOft > 1 ? wieOft + ' × ' : '') + d.name;
        }

        var daten = [zoll(d.size_inch), kilo(d.weight_g)].filter(Boolean).join(' · ');
        var datenEl = karte.querySelector('[data-mb-daten]');
        if (datenEl) datenEl.textContent = daten;

        var bildEl = karte.querySelector('[data-mb-bild]');
        var bild = bildAdresse(d.image_url);
        if (bildEl && bild) {
          var umriss = bildEl.innerHTML;
          bildEl.innerHTML = '<img src="' + esc(bild) + '" alt="" loading="lazy">';
          var img = bildEl.firstChild;
          if (img) img.onerror = function () { bildEl.innerHTML = umriss; };
        }

        var vesa = d.vesa || {};
        var lageEl = karte.querySelector('[data-mb-lage]');

        if (lageEl) {
          var kein = karte.getAttribute('data-mb-novesa') || 'Kein VESA';
          if (vesa.mount === 'NO') {
            lageEl.innerHTML = '<span class="fn-vesa-chip is-static is-none"><span>'
                             + esc(kein) + '</span></span>';
          } else if (vesa.patterns && vesa.patterns.length) {
            lageEl.innerHTML = '<span class="fn-vesa-chip is-static is-ok"><span>'
                             + esc('VESA ' + vesa.patterns[0]) + '</span></span>';
          }
        }

        d.ref = d.ref || ref;
        karte.__mbDaten = d;
        loesungFuellen(karte, d);
      }).catch(function () {
      });
    });
  });
})();
